const getters = {
  baseUrl: state => state.api.baseUrl,
  showMobile: state => state.home.showMobile
}
export default getters